var ProfileStorage = function() {
	var DEFAULT_FILTER_KEY = 'Charting.DefaultFilter.';
	this.loadDefaultFilter = function(callback, userCustNum) {
        var filter;
        var filterStr;
        try {
            filterStr = localStorage.getItem(DEFAULT_FILTER_KEY + userCustNum);
			filter = JSON.parse(filterStr);
		} catch (e) {
			console.error('Error parsing default filter: ', filterStr, e);
			filter = null;
		}

		callback && callback(filter);
	};

	this.saveDefaultFilter = function (filter, callback, userCustNum) {
	    var userKey = DEFAULT_FILTER_KEY + userCustNum;
		var filterStr = JSON.stringify(filter);
		localStorage.setItem(userKey, filterStr);
		callback && callback();
	};
};
